import { FC } from "react";

interface CheckMarkIconSVGProps {
    className?: string;
    strokeWidth?: string;
}

const CheckMarkIconSVG: FC<CheckMarkIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.5 8.4L5.82532 13.7659C5.915 13.8772 6.08903 13.8612 6.15698 13.7355L12.5 2"
                stroke="#fff"
                strokeWidth={props.strokeWidth || "2.5"}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default CheckMarkIconSVG;
